<template>
  <div class="box1200">
    <div class="height70"></div>
    <div class="top-text margin-top-20">
      <div class="title">请选择您要注册的类型</div>
      <div class="sort-title">每个账号只能申请一种类型，成功认证后将不可更改类型</div>
    </div>
    <div class="selectType flex justify-content">
      <el-tooltip effect="dark" placement="top">
        <div slot="content" style="line-height: 30px;">① 如实填写企业相关信息并提交资料<br/>② 工作人员将在3个工作日内核实资料<br/>③ 通过企业认证，成为{{this.$store.state.siteName}}的企业用户</div>
        <router-link to="enterprise-register/attestation" class="item flex align-items justify-content">
          <div class="icon"><i class="el-icon-office-building"></i></div>
          <div class="text">
            <p class="title">我是企业</p>
            <p class="sort-title">我有内容要推广</p>
          </div>
        </router-link>
      </el-tooltip>
      <el-tooltip effect="dark" placement="top">
      <div slot="content" style="line-height: 30px;">① 如实填写个人信息并提交资料，进行线上培训<br/>② 通过线上培训后工作人员将在3个工作日内核实资料<br/>③ 通过达人认证，成为{{this.$store.state.siteName}}的达人用户</div>
      <div @click="judgeArea" class="item flex align-items justify-content">
        <div class="icon"><i class="el-icon-user"></i></div>
        <div class="text">
          <p class="title">我是达人</p>
          <p class="sort-title">我有粉丝有流量</p>
        </div>
      </div>
    </el-tooltip>
    </div>
  </div>
</template>
<script>
import {checkAddress} from '@/config/api.js'
import axios from 'axios'
export default {
  name: 'RegisterType',
  methods: {
    judgeArea () {
      axios.get(checkAddress)
              .then(res => {
                if (res.data.code === 10000) {
                  this.$router.push('/daren-attestation')
                } else {
                  this.$message.error('很抱歉，当前申请达人城市仅限梅州市，您未在此区域内，更多开通城市敬请期待');
                }
              })
              .catch(err => {
                window.console.log(err);
              })
    }
  }
}
</script>
<style scoped>
  .top-text{text-align: center;margin:80px 0;}
  .top-text .title{font-size:24px;margin:0 0 10px 0;color:#fff;}
  .top-text .sort-title{font-size:14px;color:#fff;}
  .selectType{margin-bottom:100px;}
  .selectType .item{width:390px;height:240px;cursor:pointer;background:#fff;margin:0 15px;-webkit-transition: all 0.3s ease-in;-moz-transition: all 0.3s ease-in;transition: all 0.3s ease-in;-o-transition: all 0.3s ease-in;}
  .selectType .item:hover{color:#FF741F;box-shadow: 0 0 16px rgba(0,0,0,.15)}
  .selectType .item .icon{font-size:60px;}
  .selectType .item .text{margin-left:20px;}
  .selectType .item .text .title{font-size:24px;}
  .selectType .item .text .sort-title{line-height:30px;color:#999;-webkit-transition: all 0.3s ease-in;-moz-transition: all 0.3s ease-in;transition: all 0.3s ease-in;-o-transition: all 0.3s ease-in;}
  .selectType .item:hover .text .sort-title{color:#FF741F;}
</style>
